import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { UserStore } from '@/app/platform/platform-core/user/store/user.store';
import { UserQueries } from '@/app/platform/platform-core/user/store/types';
import { PlatformUser } from '@/app/platform/platform-core/user/models/platform-user';
import { UserEgiApp } from '@/app/platform/platform-core/user/models/user-egi-app';

@Injectable({
  providedIn: 'root'
})
export class UserStoreQueries implements UserQueries {
  constructor(private readonly userStore: UserStore) {}

  // Bewust select().pipe(map(...)) zoals onder Akita: deze twee emitteren bij elke
  // state-wijziging, ook als de waarde gelijk bleef.
  readonly authenticatedUser$: Observable<PlatformUser | undefined> = this.userStore
    .select()
    .pipe(map(state => state.authenticatedUser));
  readonly availableApps$: Observable<UserEgiApp[]> = this.userStore
    .select()
    .pipe(map(state => state.authenticatedUserApps));
  readonly isAnyUserAuthenticated$: Observable<boolean> = this.authenticatedUser$.pipe(
    map(u => !!u)
  );

  getIsAnyUserAuthenticated(): boolean {
    return !!this.userStore.getValue().authenticatedUser;
  }

  readonly presentUserNames$: Observable<string[]> = this.userStore.select(s => s.presentUserNames);

  getAuthenticatedUser(): PlatformUser | undefined {
    return this.userStore.getValue().authenticatedUser;
  }

  getAvailableApps(): UserEgiApp[] {
    return this.userStore.getValue().authenticatedUserApps;
  }

  readonly authenticatedUserToken$: Observable<string> = this.userStore.select(s => s.authenticatedUserToken);

  getAuthenticatedUserToken(): string {
    return this.userStore.getValue().authenticatedUserToken;
  }

  isAuthenticatedUserTokenStale(): boolean {
    const { authenticatedUserToken, authenticatedUserTokenRenewAt } = this.userStore.getValue();
    return (
      !!authenticatedUserToken &&
      authenticatedUserTokenRenewAt !== undefined &&
      Date.now() >= authenticatedUserTokenRenewAt
    );
  }

  readonly hasNoAppsWithAccess$: Observable<boolean> = this.userStore
    .select(s => s.authenticatedUserApps)
    .pipe(map(apps => apps.every(a => !a.rootNavigationItem.isBaseAccessAllowed)));

  getHasNoAppsWithAccess(): boolean {
    return this.getAvailableApps().every(a => !a.rootNavigationItem.isBaseAccessAllowed);
  }

  getUserHasJustChanged(): boolean {
    return this.userStore.getValue().userHasJustChanged;
  }
}
